import type { PhotosetWithAssets } from '../../../types/asset.types';

/**
 * Pick the most-recently-created photoset from the list returned by
 * assetApi.useGetPhotosetsQuery. Used by both the property-detail drawer
 * and the property-detail page so the hero image matches across surfaces.
 *
 * Sort matches the manage-assets page (usePropertyAssets.ts) — uses
 * Date comparison rather than string localeCompare. Backend ordering
 * isn't guaranteed; in practice some createdAt timestamps don't sort
 * correctly lexicographically (likely a non-strict ISO format somewhere),
 * so always normalize through Date.
 */
export function pickLatestPhotoset(
  photosets: PhotosetWithAssets[] | undefined,
): PhotosetWithAssets | null {
  if (!photosets || photosets.length === 0) return null;
  if (photosets.length === 1) return photosets[0];
  return [...photosets].sort(
    (a, b) =>
      new Date(b.photoset.createdAt ?? 0).getTime() -
      new Date(a.photoset.createdAt ?? 0).getTime(),
  )[0];
}
